module.exports = __webpack_public_path__ + "44871bdbba517eb8df02fa05b8e3c9d3.svg";